import { createRequestTypes, generateRequestActions } from 'utils/actionHelpers/actionHelpers'

export const GET_DEPARTMENTS = createRequestTypes('GET_DEPARTMENTS')

export const getDepartments = generateRequestActions(GET_DEPARTMENTS)
